module.exports = __webpack_public_path__ + "img/pinterest.f094a426.png";